import { createLogger } from "logging";
import { useEffect, useRef } from "react";

const logger = createLogger("UploadFile");

interface UploadDocumentProps {
  uploadFileAgendaItemId: number;
  setUploadFileAgendaItemId: (id: number) => void;
  onFileChanged: (file: File) => void;
}

export const UploadDocument: React.FC<UploadDocumentProps> = ({
  uploadFileAgendaItemId,
  setUploadFileAgendaItemId,
  onFileChanged,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (uploadFileAgendaItemId <= 0) {
      return;
    }

    fileInputRef.current?.click();
    logger.debug(`uploadFileAgendaItemId(): Picking file...`, uploadFileAgendaItemId);
  }, [uploadFileAgendaItemId]);

  return (
    <input
      type="file"
      style={{ display: "none" }}
      onChange={(e) => {
        const files = e.target.files;
        if (files == null || files.length === 0) {
          setUploadFileAgendaItemId(0);
          return;
        }

        const file = files[0];
        if (file == null) {
          setUploadFileAgendaItemId(0);
          return;
        }

        onFileChanged(file);
        e.target.value = "";
      }}
      ref={fileInputRef}
    />
  );
};
